import { entries } from "lodash";
import { mainConfig, Plot } from "../../../../../common";
import { DashboardSkeleton } from "../../../../../dashboard/DashboardSkeleton";
import { DashboardWidget, DashboardWidgetContent, DashboardWidgetHeader } from "../../../../../dashboard/widget";
import { Layout } from "plotly.js";
import { constants } from "../../../../../../constants/constants";
import { formatUtils } from "../../../../../../utils/format.utils";

const font = {
    family: 'Roboto, Arial, Helvetica, sans-serif',
    size: 12,
    color: '#4a4a4a'
};

interface Props {
    chartName: string
    targetParByRating: Record<string, number>
}

export function PortfolioStatisticsChart({ chartName, targetParByRating }: Props) {
    const data = entries(targetParByRating).reverse()

    const layout: Partial<Layout> = {
        height: data.length * 25,
        barmode: 'stack',
        autosize: true,
        showlegend: false,
        margin: { t: 0, r: 45, b: 10, l: 40 },
        font,
        dragmode: false,
        hoverlabel: {
            bgcolor: '#4a4a4a',
            bordercolor: '#4a4a4a',
            font: {
                ...font,
                color: '#ffffff'
            },
            align: 'left',
        },
        xaxis: {
            range: [0, 100],
            showticklabels: false,
            showgrid: false,
            zeroline: false,
            fixedrange: true,
        },
        yaxis: {
            showgrid: false,
            showtickprefix: 'none',
            zeroline: false,
            tickcolor: 'transparent',
            fixedrange: true,
        }
    };

    const chartData = [{
        y: data.map(([rating]) => rating.toString()),
        x: data.map(([, percent]) => percent),
        type: 'bar',
        orientation: 'h',
        hovertemplate: '%{y}: %{x:.2f}%',
        name: '',
        marker: {
            color: '#5b74a5',
            line: {
                width: 0.3
            }
        },
    }, {
        y: data.map(([rating]) => rating.toString()),
        x: data.map(([, percent]) => 100 - percent),
        type: 'bar',
        orientation: 'h',
        hoverinfo: 'none',
        marker: {
            color: '#F5F5F5',
        },
        text: data.map(([, percent]) => percent ? `${formatUtils.formatDecimal(percent)}%` : constants.emptyPlaceholder),
        textposition: 'outside',
        cliponaxis: false
    }];

    return (
        <DashboardWidget title={chartName}>
            <DashboardSkeleton>
                <DashboardWidgetHeader>
                    <h3>{chartName}</h3>
                </DashboardWidgetHeader>
                <DashboardWidgetContent>
                    <Plot
                        layout={layout}
                        data={chartData}
                        config={mainConfig}
                    />
                </DashboardWidgetContent>
            </DashboardSkeleton>
        </DashboardWidget>
    );
}